import React, { useEffect, useState } from 'react';
import './bankaccount.scss';
import divider from "../../../../images/Vector 11.png";
import { useSelector } from 'react-redux';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import SellerNavigationComponent from './SellerNavigationComponent';
const baseUrl = process.env.REACT_APP_BASEURL;
const BankAccount = () => {
  const [details, setDetails] = useState("");
  const [newData, setNewData] = useState({});
  const navigate=useNavigate();
  const state = useSelector((state) => state.sellers);
  const { sellerAuth, profile } = state;
  const handleChange = (event) => {
    const { name, value } = event.target;
  
    if (name === "Accountnumber" && value.length > 12) {
      return;
    }
    setNewData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleIFSCChange = (event) => {
    const { value } = event.target;
    const regex = /^[A-Z0-9]{0,11}$/; // Regular expression for uppercase letters and numbers, with maximum length of 11
    if (regex.test(value)) {
      setNewData((prevData) => ({ ...prevData, IFSC: value }));
    }
  };
  const handleholdernameChange = (event) => {
    const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Regular expression to allow only alphabets and spaces
    if (regex.test(value)) {
      setNewData((prevData) => ({ ...prevData, Accountholdername: value }));
    }
  };
  const [data, setData] = useState("");
  const fetchsinglesellerdetail = async () => {
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id);
    try {
      const response = await axios.get(`${baseUrl}/api/reseller/${sellerInfoObject?._id}`);
      setNewData(response?.data[0]);
      console.log(response?.data[0],"erere");
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchsinglesellerdetail();
  }, []);
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `${baseUrl}/api/reseller/editdetails/${details[0]?._id}`,
        newData
      );

      console.log("Product updated:", response.data);
      toast.success("Details updated")
   
  
    } catch (error) {
      console.error("Failed to update product", error);
    }
  };
  useEffect(() => {
    const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller: sellerAuth?._id,
        }
      );
      setDetails(response.data);
      console.log(response.data, "llll");
    };
    fetchDetails();
  }, []);
   const handleSubmit = async (e) => {
    e.preventDefault();
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
    console.log(sellerInfoObject?._id);
    try {
      const response = await axios.post(
        `${baseUrl}/api/reseller/editdetails/${sellerInfoObject?._id}`,
        newData,sellerInfoObject?._id
      );
      console.log(response.data);
      // fetchSingleSeller();
toast.success("Updated")
    } catch (error) {
      console.log(error);
    }
  };
  return (
//     <div>
//       <ToastContainer/>
//     <div style={{ display: "flex" }}>
//       <SellerNavigationComponent/>
//         <img src={divider} className="divider" />
//         <div>
//         <form onSubmit={handleFormSubmit}>
//           <p className='enteraccountdetails'>Enter Your Bank Account Details* </p>
//           <div  style={{ display: "flex" }}>

//           <input className='editaccountholdernameinput'  value={newData.Accountholdername} placeholder={details[0]?.Accountholdername} id="Accountholdername"
//           name="Accountholdername"  onChange={handleChange}/>
//           <input className='editifscinput' 
//            id="IFSC"
//           value={newData.IFSC}
//           name="IFSC" placeholder={details[0]?.IFSC}  onChange={handleChange}
//           />
          
//           </div>
//           <input className='editaccountholdernameinputOne'
//           id="Accountnumber"
//           name="Accountnumber"
//            placeholder={details[0]?.Accountnumber} 
//             onChange={handleChange}
//             value={newData.Accountnumber}
//              />
//           <div>

//           <button className='sendforreviewbutton'><p className='sendforreviewtext'>Send For Review</p></button>
//           </div>
//           </form>
//         </div>
//         </div>
//     </div>
//   )
// }

// export default BankAccount;
  <div>
    <ToastContainer/>
    <div style={{ display: "flex" }}>
      <SellerNavigationComponent/>
      <img src={divider} className="divider" />
      <div className='bankdetailmain'>
        <form onSubmit={handleFormSubmit}>
          <div>
          <p className='enteraccountdetails'>Enter Your Bank Account Details<span style={{ color: 'red' }}>*</span> </p>
          <div style={{ display: "flex" ,justifyContent:"space-between"}}>
          {/* <p className='accounttextOne'>Enter Account Holder Name</p> */}
<div style={{display:"flex"}}>
<input
              className='editaccountholdernameinput'
              value={newData.Accountholdername}
              // placeholder={data?.Accountholdername} // Placeholder for Name
              id="Accountholdername"
              name="Accountholdername"
              
              onChange={handleholdernameChange}
            />
  <p className='accounttextOne'>Enter Account Holder Name<span style={{ color: 'red' }}>*</span></p>
</div>
            
<div style={{display:"flex"}}>
<input
              className='editifscinput'
              value={newData.IFSC}
              placeholder={data?.IFSC} // Placeholder for IFSC code
              id="IFSC"
              name="IFSC"
              onChange={handleIFSCChange}
              maxLength={11}
              pattern="[A-Z0-9]{11}"
            />
  <p className='accounttextTwo'>IFSC CODE<span style={{ color: 'red' }}>*</span></p>
</div>
            
          </div>        
<div
 style={{display:'flex'}}
>

          <input
            className='editaccountholdernameinputOne'
            id="Accountnumber"
            type='Number'
            name="Accountnumber"
            placeholder={data?.Accountnumber} // Placeholder for Account number
            onChange={handleChange}
            value={newData.Accountnumber} 
          />
  <p className='accounttextThree'>Enter Account-number<span style={{ color: 'red' }}>*</span></p>
</div>

<div className='sndbuttonbnk'>
            <button       onClick={handleSubmit}            
  className='sendforreviewbutton'>Send For Review</button>
          </div>
</div>
        </form>
      </div>
    
    </div>
  </div>
)
}

export default BankAccount;